/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, TemplateRef } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[ghGridSelectBarTemplate]',
})
export class GridSelectBarTemplateDirective {
  constructor(public templateRef: TemplateRef<any>) {
  }
}
